
// The pre-check bypass is simple.
// Always return a constant dictionary to machine that passes all check thresholds.
export const preCheckBypass = async () => {

    return {
        checkImage: async (
            imageStr,
            landmarks,
            skipEars = false,
            imgTensor = null,
            imgBytes = null,
            width = null,
            height = null
        ) => {

            return {
                "lightingResults": {
                    "dark": {
                        "value": 173,
                        "threshold": 100
                    },
                    "light": {
                        "value": 32,
                        "threshold": 155
                    },
                    "contrast": {
                        "low_contrast": false,
                        "ratio": 0.5529411764705883
                    }
                },
                "blurInfo": {
                    "width": 120,
                    "height": 173,
                    "num_edges": 480,
                    "edge_ratio": 0.023121387283236993,
                    "avg_edge_width": 3.7270833333333333,
                    "avg_edge_width_perc": 3.105902777777778
                }
            }
        }
    }
}